let Tabs = {}

$(document).ready(function ($) {

    $('[data-tabs]').on('click', '[data-item-nav-tabs]', function(e){
        var _this = $(this);        

        if(!_this.hasClass('active')){
            var container = _this.closest('[data-tabs]'),
            value = _this.data('item-nav-tabs');

            container.find('[data-tab-pane]').removeClass('active');
            container.find('[data-item-nav-tabs]').removeClass('active');

            _this.addClass('active');
            $('[data-tab-pane="' + value + '"]').addClass('active');
        }
    });

    let selectNavTabsMobile = $('[data-select-nav-tabs-mobile]');
    if(selectNavTabsMobile.length) {
        var $select = $('[data-select-nav-tabs-mobile]').selectize({
            onChange: function(value){
                var elem = this.$input[0],
                    container = $(elem).closest('[data-tabs]');

                // fix бага selectize с выбранным элементом
                container.find('.option').removeClass('selected');
                container.find('[data-value="'+value+'"].option').addClass('selected');
                
                container.find('[data-tab-pane]').removeClass('active');
                $('[data-tab-pane="' + value + '"]').addClass('active');
            }
        });
    }    
});



// WEBPACK FOOTER //
// ./components/tabs.js